/** @jsx h */
import { h } from 'preact'

import Details from '../Details'
import IconDown from '../../../../assets/images/svgs/icon-chevron-down.svg'
import UserProfile from '../UserProfile'
import StoryButtonList from './stories/StoryButtonList'
import t from '../../../utils/translate'

const QuoteSection = ({ quote, subject, initiatives, issuer, journeys, onStoryClick, name, analyticsContext }) =>
  <section class='ModalCard-section ModalCard-section--ugc'>
    <blockquote>
      {issuer &&
        <UserProfile {...issuer} citation={subject && subject.name} />}

      <q class='Quote CaptionUI--emphasis'>{quote}</q>
    </blockquote>

    <StoryButtonList
      journeys={journeys}
      onStoryClick={onStoryClick}
      name={name}
      analyticsContext={analyticsContext}
      fullWidthImage
    />

    {initiatives.length > 0 &&
      <Details className='Details--plain' analyticsName='howAchievedDetails' analyticsContext={analyticsContext}>
        <summary class='BodyUI--regular | flex items-center'>
          {t('proof_points.js.claims.how_achieved')}
          <IconDown class='chevron' aria-hidden />
        </summary>
        <ul class='ModalCard-list'>
          {initiatives.map((item, idx) =>
            <li class='ModalCard-listItem' key={`initiative-${idx}`}>{item}</li>
          )}
        </ul>
      </Details>}
  </section>

QuoteSection.defaultProps = {
  initiatives: [],
  issuer: null,
  journeys: []
}

export default QuoteSection
